// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/trading_delivery_type.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bfftypes/v1/trading_delivery_type.proto.
 */
export const file_bfftypes_v1_trading_delivery_type: GenFile = /*@__PURE__*/
  fileDesc("CidiZmZ0eXBlcy92MS90cmFkaW5nX2RlbGl2ZXJ5X3R5cGUucHJvdG8SC2JmZnR5cGVzLnYxKscCChNUcmFkaW5nRGVsaXZlcnlUeXBlEiUKIVRSQURJTkdfREVMSVZFUllfVFlQRV9VTlNQRUNJRklFRBAAEhwKGFRSQURJTkdfREVMSVZFUllfVFlQRV9CRxABEiAKHFRSQURJTkdfREVMSVZFUllfVFlQRV9FQ0xFQVIQAhIeChpUUkFESU5HX0RFTElWRVJZX1RZUEVfU1dBUBAEEh8KG1RSQURJTkdfREVMSVZFUllfVFlQRV9UT0NPTRAFEh0KGVRSQURJTkdfREVMSVZFUllfVFlQRV9FRVgQBhIdChlUUkFESU5HX0RFTElWRVJZX1RZUEVfSUNFEAcSHgoaVFJBRElOR19ERUxJVkVSWV9UWVBFX0pFUFgQCCIECAMQAyokVFJBRElOR19ERUxJVkVSWV9UWVBFX0JBQ0tVUF9SRUdVTEFSQkJaQGdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnR5cGVzL3YxO2JmZnR5cGVzdjFiBnByb3RvMw");

/**
 * TradingDeliveryType は相対取引の受渡区分を表す enum 固定値。
 * internalapi (types.v1.TradingDeliveryType) と 1:1 でミラーする BFF / frontend 向け wire type。
 * 旧 master 化 (= ytnsym #613-1 DB マスタ行) を廃止し、 proto enum に巻き戻し。
 * 値セットは mock-app (= 受渡区分の正本) に準拠した 7 値:
 * BG / eClear / スワップ / TOCOM / EEX / ICE / JEPX (相対 JEPX 渡し契約)。
 * 「常時バックアップ」 は受渡区分ではなく約定経路 (TradingExecutionRoute の常時BU)
 * として管理する (issue #1586)。常時BU は受渡区分上は BG 渡し。
 *
 * 派生属性 (is_physical / requires_settlement_price_area) は enum 値から導出可能であり、
 * frontend がマッピング関数で解決する (マスタ行 fetch 不要)。
 *
 *   BG経由 (1-2) + JEPX (8):  is_physical=true,  requires_settlement_price_area=false
 *   物理受渡なし (4-7):        is_physical=false, requires_settlement_price_area=true
 *
 * @generated from enum bfftypes.v1.TradingDeliveryType
 */
export enum TradingDeliveryType {
  /**
   * @generated from enum value: TRADING_DELIVERY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * BG — BG経由 (物理受渡)
   *
   * @generated from enum value: TRADING_DELIVERY_TYPE_BG = 1;
   */
  BG = 1,

  /**
   * ECLEAR — eClear / BG経由 (物理受渡)
   *
   * @generated from enum value: TRADING_DELIVERY_TYPE_ECLEAR = 2;
   */
  ECLEAR = 2,

  /**
   * SWAP — スワップ / 物理受渡なし (差金決済)
   *
   * @generated from enum value: TRADING_DELIVERY_TYPE_SWAP = 4;
   */
  SWAP = 4,

  /**
   * TOCOM — TOCOM / 物理受渡なし (差金決済)
   *
   * @generated from enum value: TRADING_DELIVERY_TYPE_TOCOM = 5;
   */
  TOCOM = 5,

  /**
   * EEX — EEX / 物理受渡なし (差金決済)
   *
   * @generated from enum value: TRADING_DELIVERY_TYPE_EEX = 6;
   */
  EEX = 6,

  /**
   * ICE — ICE / 物理受渡なし (差金決済)
   *
   * @generated from enum value: TRADING_DELIVERY_TYPE_ICE = 7;
   */
  ICE = 7,

  /**
   * JEPX — 相対 JEPX 渡し契約 (JEPX スポット市場を介して受渡する相対契約)。
   * is_physical=true (mock-app SoT 準拠), requires_settlement_price_area=false。
   * internalapi (types.v1.TradingDeliveryType) の wire 値と一致。
   *
   * @generated from enum value: TRADING_DELIVERY_TYPE_JEPX = 8;
   */
  JEPX = 8,
}

/**
 * Describes the enum bfftypes.v1.TradingDeliveryType.
 */
export const TradingDeliveryTypeSchema: GenEnum<TradingDeliveryType> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_trading_delivery_type, 0);

